import React, { Fragment, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import debounce from 'lodash.debounce';
import {
  //setRefundable,
  setCamperField,
  setParentField,
} from '../reducers/form';
//import { setCartRefundable } from '../reducers/cart';
import API from '../utils/api';
import { getIsAdult, isEmail } from '../utils/helpers';
import GTMService, { TYPES } from '../utils/gtm';

const api = new API();
const gtm = new GTMService();

const StepThree = ({
  //defaultRefundable,
  //forcedRefundable,
  secondaryPositions,
  cartId,
  products,
  //refundable,
  camper,
  parent,
  setCamperField,
  setParentField,
  //setCartRefundable,
}) => {
  //const [refundablePrice, setRefundablePrice] = useState(null);
  const [sizes, setSizes] = useState([]);
  const [isCamperEmailValid, setIsCamperEmailValid] = useState(null);
  const [isParentEmailValid, setIsParentEmailValid] = useState(null);
  const isAdult = getIsAdult(camper.age);

  /*
  useEffect(() => {
    if (!forcedRefundable) {
      return;
    }

    setCartRefundable(forcedRefundable);
  }, [forcedRefundable, setCartRefundable]);
  */

  useEffect(() => {
    api.fetchSizes(camper.gender).then((data) => {
      console.log('StepThree', data);
      setSizes(data.sizes);
    });
  }, [camper]);

  /*
  useEffect(() => {
    if (typeof defaultRefundable !== 'boolean') {
      return;
    }

    setCartRefundable(defaultRefundable);
  }, [defaultRefundable, setCartRefundable]);
  */

  const debouncedTrackCamperInformation = useRef(
    debounce((parent) => {
      const parentKeysToCheck = Object.keys(parent);
      const hasValidData = parentKeysToCheck.every((key) => !!parent[key]);
      if (hasValidData) {
        gtm.trackChange(TYPES.OR_CAMPER_INFORMATION);
      }
    }, 5000)
  );

  useEffect(
    () => debouncedTrackCamperInformation.current(parent),
    [parent, camper.secondaryPosition, camper.shirtSize]
  );

  const debouncedTrackCamperEmail = useRef(
    debounce(() => {
      gtm.trackChange(TYPES.OR_CAMPER_EMAIL);
    }, 5000)
  );

  useEffect(() => {
    debouncedTrackCamperEmail.current();

    // Validate
    setIsCamperEmailValid(camper.email ? isEmail(camper.email) : null);
  }, [camper.email]);

  useEffect(() => {
    setIsParentEmailValid(parent.email ? isEmail(parent.email) : null);
  }, [parent.email]);

  /*
  useEffect(() => {
    let skip = false;
    api.calculateCartRefundable(cartId).then((res) => {
      if (skip) {
        return;
      }

      console.log('setRefundablePrice', res);

      setRefundablePrice(res.total_price_difference);
    });
    return () => (skip = true);
  }, [products, cartId]);
  */

  /*
  const handleChangeRefundable = (value) => {
    setCartRefundable(value);
  };
  */

  // Sets the camper field only if the input is all letters.
  const handleChangeCamperField = (key, value) => {
    const re = /^[a-zA-Z ]*$/;
    if (re.test(value)) {
      setCamperField(key, value);
    }
  };

  // Sets the parent field only if the input is all letters.
  const handleChangeParentField = (key, value) => {
    const re = /^[a-zA-Z ]*$/;
    if (re.test(value)) {
      setParentField(key, value);
    }
  };

  /*
  const renderRefundableLabels = () => {
    if (forcedRefundable) {
      return (
        <label
          className={classNames('field__label', {
            'field__input--selected': true,
          })}
        >
          Now included free + $0
          <input
            type="radio"
            name="refundable"
            className="field__input"
            required
            checked
          />
        </label>
      );
    }

    return (
      <Fragment>
        <label
          className={classNames('field__label', {
            'field__input--selected': !!refundable,
          })}
        >
          Yes + ${Math.round(refundablePrice)}
          <input
            type="radio"
            name="refundable"
            className="field__input"
            required
            defaultChecked={
              typeof defaultRefundable === 'boolean' && !!defaultRefundable
            }
            onChange={() => handleChangeRefundable(true)}
          />
        </label>
        <label
          className={classNames('field__label', {
            'field__input--selected': refundable === false,
          })}
        >
          No
          <input
            type="radio"
            name="refundable"
            required
            defaultChecked={
              typeof defaultRefundable === 'boolean' && !defaultRefundable
            }
            onChange={() => handleChangeRefundable(false)}
          />
        </label>
      </Fragment>
    );
  };
  */

  //console.log('camper:', camper);

  return (
    <Fragment>
      {/*
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="field">
          <h4 className="field__title">
            Do you require a refundable camp registration?
          </h4>
          <div className="refundable-btn-holder">
            {renderRefundableLabels()}
            <div
              className="info"
              onClick={() => {
                if (typeof window.reactOpenPopup === 'function') {
                  window.reactOpenPopup('refundable');
                }
              }}
            ></div>
          </div>
        </div>
      </form>
      */}

      <div className="row">
        <div className="col-xs-12 col-sm-6">
          <form className="form" onSubmit={(e) => e.preventDefault()}>
            <div className="field">
              <h4 className="field__title">Camper information</h4>
              <label
                className={classNames('field__label field__display--input', {
                  'field__input--selected': camper.firstName !== '',
                })}
              >
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={camper.firstName}
                  required
                  onChange={(e) => handleChangeCamperField('firstName', e.target.value)}
                />
              </label>
              <label
                className={classNames('field__label field__display--input', {
                  'field__input--selected': camper.lastName !== '',
                })}
              >
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={camper.lastName}
                  required
                  onChange={(e) => handleChangeCamperField('lastName', e.target.value)}
                />
              </label>
              <label
                className={classNames('field__label field__display--input', {
                  'field__input--selected': (camper.email !== null && camper.email !==""),
                  'field__input--error': isCamperEmailValid === false,
                })}
              >
                <input
                  type="email"
                  name="email"
                  placeholder={`Email ${isAdult ? '' : '(optional)'}`}
                  value={camper.email}
                  onChange={(e) => setCamperField('email', e.target.value)}
                />
              </label>
              <label
                className={classNames('field__label field__display--input', {
                  'field__input--selected': camper.phoneNumber !== '',
                })}
              >
                <input
                  type="text"
                  name="phoneNumber"
                  placeholder={`Phone number ${isAdult ? '' : '(optional)'}`}
                  value={camper.phoneNumber}
                  onChange={(e) =>
                    setCamperField('phoneNumber', e.target.value)
                  }
                />
              </label>
            </div>
          </form>
        </div>

        <div className="col-xs-12 col-sm-6">
          <form className="form" onSubmit={(e) => e.preventDefault()}>
            <div className="field select">
              <h4 className="field__title">Sizes</h4>
              <label
                className={classNames('field__label select', {
                  'field__input--selected': camper.shirtSize !== '',
                })}
              >
                <select
                  type="text"
                  name="position"
                  className="field__select"
                  value={camper.shirtSize}
                  required
                  onChange={(e) => setCamperField('shirtSize', e.target.value)}
                >
                  <option value="">Select Shirt Size</option>
                  {Object.keys(sizes).map((key) => (
                    <option key={key} value={key}>
                      {sizes[key]}
                    </option>
                  ))}
                </select>
              </label>

              <label
                className={classNames('field__label select', {
                  'field__input--selected': camper.shortSize !== '',
                })}
              >
                <select
                  type="text"
                  name="position"
                  className="field__select"
                  value={camper.shortSize}
                  onChange={(e) => setCamperField('shortSize', e.target.value)}
                >
                  <option value="">Select Short Size</option>
                  {Object.keys(sizes).map((key) => (
                    <option key={key} value={key}>
                      {sizes[key]}
                    </option>
                  ))}
                </select>
              </label>
            </div>
          </form>
        </div>
      </div>

      {!isAdult && (
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="field">
            <h4 className="field__title">Parent/Guardian Information</h4>
            <label
              className={classNames('field__label field__display--input', {
                'field__input--selected': parent.firstName !== '',
              })}
            >
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={parent.firstName}
                required
                onChange={(e) => handleChangeParentField('firstName', e.target.value)}
              />
            </label>
            <label
              className={classNames('field__label field__display--input', {
                'field__input--selected': parent.lastName !== '',
              })}
            >
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={parent.lastName}
                required
                onChange={(e) => handleChangeParentField('lastName', e.target.value)}
              />
            </label>
            <label
              className={classNames('field__label field__display--input', {
                'field__input--selected': parent.email !== '',
                'field__input--error': isParentEmailValid === false,
              })}
            >
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={parent.email}
                required
                onChange={(e) => setParentField('email', e.target.value)}
              />
            </label>
            <label
              className={classNames('field__label field__display--input', {
                'field__input--selected': parent.phoneNumber !== '',
              })}
            >
              <input
                type="text"
                name="phoneNumber"
                placeholder="Phone number"
                value={parent.phoneNumber}
                required
                onChange={(e) => setParentField('phoneNumber', e.target.value)}
              />
            </label>
          </div>
        </form>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  cartId: state.cart.cart.id,
  products: state.cart.cart.participants[0].products,
  //refundable: state.form.refundable,
  camper: state.form.camper,
  parent: state.form.parent,
  //forcedRefundable: state.form.forcedRefundable,
});

const mapDispatchToProps = (dispatch) => ({
  /*
  setCartRefundable: (value) => {
    dispatch(setRefundable(value));
    dispatch(setCartRefundable(value));
  },
  */
  setCamperField: (key, value) => dispatch(setCamperField(key, value)),
  setParentField: (key, value) => dispatch(setParentField(key, value)),
});

StepThree.propTypes = {
  //defaultRefundable: PropTypes.bool,
  cartId: PropTypes.number,
  products: PropTypes.array,
  //refundable: PropTypes.bool,
  //forcedRefundable: PropTypes.bool,
  camper: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    position: PropTypes.string,
    shirtSize: PropTypes.string,
    role: PropTypes.string,
  }).isRequired,
  parent: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
  }).isRequired,
  secondaryPositions: PropTypes.array,
  //setCartRefundable: PropTypes.func.isRequired,
  setParentField: PropTypes.func.isRequired,
  setCamperField: PropTypes.func.isRequired,
};

StepThree.displayName = 'StepThree';

export default connect(mapStateToProps, mapDispatchToProps)(StepThree);
